import { PageContainer } from "../../components/PageComponents";
import { Summary, UserActivity, Revenue } from "./components";
import Leaderboard from "./Leaderboard";

const Dashboard = () => {
  const summaryData = {
    users: 100,
    productPurchased: 100,
    coinsPurchased: 14,
    revenue: 500000,
  };

  return (
    <PageContainer title="Dashboard">
      <Summary {...summaryData} />
      <div className="col-6">
        <div className="row-2">
          <UserActivity />
          <Leaderboard />
        </div>
        <Revenue />
      </div>
    </PageContainer>
  );
};

export default Dashboard;
